

export async function serDEK(dek: CryptoKey) {
  const exportedKey = await crypto.subtle.exportKey('jwk', dek);
  const json = JSON.stringify(exportedKey);
  const fileData = new TextEncoder().encode(json);
  return fileData;
}

export async function deSerDEK(data: Uint8Array | ArrayBuffer) {
  const json = new TextDecoder().decode(data);
  const keyData = JSON.parse(json);
  const key = await crypto.subtle.importKey(
    'jwk',
    keyData,
    { name: 'AES-GCM' },
    false,
    ['encrypt', 'decrypt']
  );
  if (!key || !(key instanceof CryptoKey)) {
    throw new Error('Failed to import DEK from JWK');
  }
  return key;
}

export async function serBlob(blob: Blob) {
  const fileData = await blob.arrayBuffer();
  return fileData;
}
